{
    "LicenceManagementPage_Title": "Licence Management",
    "LicenceManagementPage_Subtitle": "Manage device and user assignments for a selected telephony scope.",
    "LicenceManagementPage_Tile_Analytics": "CX Analytics",
    "LicenceManagementPage_Tile_Score": "CX Score",
    "LicenceManagementPage_Tile_Record": "CX Record",
    "LicenceManagementPage_Tile_Integration": "CX Integration",
    "LicenceManagementPage_Tile_Licences": "Licences",
    "LicenceManagementPage_Column_DeviceNumber": "Device",
    "LicenceManagementPage_Column_Username": "User name",
    "LicenceManagementPage_Column_Email": "Email",
    "LicenceManagementPage_Column_HasDevice": "Device",
    "LicenceManagementPage_Column_Agent": "Agent",
    "LicenceManagementPage_Column_WelcomeEmail": "Welcome Email",
    "LicenceManagementPage_Column_Licences": "Licences",
    "LicenceManagementPage_Column_Actions": "Actions",
    "LicenceManagementPage_Type_Device": "Device",
    "LicenceManagementPage_Type_User": "User",
    "LicenceManagementPage_Popup_TelSys": "Telephony server",
    "LicenceManagementPage_Popup_Partition": "Partition",
    "LicenceManagementPage_Popup_Device": "Device",
    "LicenceManagementPage_Popup_Username": "Username",
    "LicenceManagementPage_Popup_Email": "Email",
    "LicenceManagementPage_Popup_Close": "Close",
    "LicenceManagementPage_LicencePopup_Title": "Manage Product Licenses",
    "LicenceManagementPage_LicencePopup_Licence": "License",
    "LicenceManagementPage_LicencePopup_ScoreUserCalls": "Score User Calls",
    "LicenceManagementPage_LicencePopup_RecordUserCalls": "Record User Calls",
    "LicenceManagementPage_LicencePopup_IntegrationEnabled": "Enabled",
    "LicenceManagementPage_LicencePopup_CxiUser": "CXI User",
    "LicenceManagementPage_LicencePopup_CxiData": "CXI Data",
    "LicenceManagementPage_LicencePopup_On": "On",
    "LicenceManagementPage_LicencePopup_Off": "Off",
    "LicenceManagementPage_LicencePopup_Enabled": "Enabled",
    "LicenceManagementPage_LicencePopup_Disabled": "Disabled",
    "LicenceManagementPage_LicencePopup_EmailRequired": "Add an email address before saving license changes for this device.",
    "LicenceManagementPage_Email_AddTooltip": "Click to add email and create user",
    "LicenceManagementPage_EssentialsExtension": "Essentials (Extension)",
    "LicenceManagementPage_Empty": "Nothing found here",
    "LicenceManagementPage_WelcomeEmail_Title": "Resend welcome email to \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Confirm": "Would you like to resend the welcome email to \"{}\"?",
    "LicenceManagementPage_WelcomeEmail_Success": "Email was successfully sent to \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Fail": "There was an unexpected error when sending the email. Please try again.",
    "LicenceManagementPage_Licence_SaveFailed": "The user's current settings could not be read, so the licences were not saved. Please try again.",
    "LicenceManagementPage_Column_LicencesCount": "[{} Licenses]",
    "LicenceManagementPage_Tick_Save": "Save row changes",
    "LicenceManagementPage_Tick_InvalidEmail": "Enter a valid email address to create the user.",
    "LicenceManagementPage_Licence_ScoringEnabled": "Scoring Enabled",
    "LicenceManagementPage_Licence_RecordingEnabled": "Recording Enabled",
    "LicenceManagementPage_Licence_WithScoring": "{} + Scoring",
    "LicenceManagementPage_Licence_WithRecording": "{} + Recording",
    "LicenceManagementPage_Username_NoUserTooltip": "This will be used as the username when a new user is created",
    "NAME": "LicenceManagementPageLanguage"
}
